//production
export const serverUrl = "https://ayembeunion.org/api/index.php";

export const apiUrl = "https://ayembeunion.org/api";

//development
// export const apiUrl = "http://localhost/ayembe_api/api";

// export const serverUrl = "http://localhost/ayembe_api/api/index.php";